import {
  Autocomplete,
  Button,
  Checkbox,
  Collapse,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { MapContainer, Marker, TileLayer, useMapEvents, Polyline, useMap } from "react-leaflet";
import { Icon } from "leaflet";
import { clone, isEmpty, isNil } from "ramda";
import palette, { polylineColors } from "../../../../../config/colorPalette";
import { MapTypeContent } from "../../../Home/components/Map/styled";
import MapTypeSelector from "../../../Home/components/MapTypeSelector";
import { toast } from "react-toastify";
import { ErrorText } from "../AssetInfoForm/styled";
import ModalSectionInfo from "../EquipmentInfo/components/modalSectionInfo";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import styled, { ThemeProvider } from "styled-components";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { getMuiTheme } from "../../../../utils/utils";
const PolylineData = ({
  setPolyline,
  polylineDisplay,
  setPolylineDisplay,
  centroid,
  setCentroid,
  pIndexes,
  setPIndexes,
  equipmentCollection,
  equipment,
  setEquipment,
  badEquipmentList,
  setBadEquipmentList,
  edition,
  setEdition,
  zoom,
  setZoom,
  assetSubs,
  setAssetSubs,
  assetSensors,
  setAssetSensors,
  zones,
  setZones,
  errors,
  setErrors,
  intl,
}) => {
  const customIcon = new Icon({
    iconUrl: require("../../../../../images/Uptech-marker-icon.png"),
    iconSize: [50, 50],
    iconAnchor: [25, 50],
  });
  const [error, setError] = useState("");
  const theme = useMemo(() => getMuiTheme(), []);

  const BootstrapButton = styled(Button)({
    marginBottom: "5%",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: palette.primary,
    borderColor: palette.secondary,
    "&:hover": {
      backgroundColor: palette.link,
      borderColor: palette.secondary,
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: palette.link,
      borderColor: palette.secondary,
    },
    "&:focus": {
      boxShadow: "0 0 0 0.2rem rgba(134,26,33,.5)",
    },
  });
  const [substructureDataToggle, setSubstructureDataToggle] = useState([]);
  const [substructureSectionToggle, setSubstructureSectionToggle] = useState([]);
  const [substructureSectionDataToggle, setSubstructureSectionDataToggle] = useState([]);
  const [hoveredPolylineIndex, setHoveredPolylineIndex] = useState(null);

  useEffect(() => {
    const actualLength = assetSubs.length;

    const newSubAsign = [];
    const newSectionAsign = [];
    const newSectionDataAsign = [];

    for (let indexSub = 0; indexSub < actualLength; indexSub++) {
      newSubAsign.push(isNil(substructureDataToggle[indexSub]) ? false : substructureDataToggle[indexSub]);

      if (assetSubs[indexSub].type === "inclinometer") {
        newSectionAsign.push(isNil(substructureSectionToggle[indexSub]) ? false : substructureSectionToggle[indexSub]);

        const secCount = assetSubs[indexSub].sections.length;
        const prevData = substructureSectionDataToggle[indexSub];
        const sectionData = [];
        for (let indexSection = 0; indexSection < secCount; indexSection++) {
          sectionData.push(!isNil(prevData) && !isNil(prevData[indexSection]) ? prevData[indexSection] : false);
        }
        newSectionDataAsign.push(sectionData);
      } else {
        newSectionAsign.push(null);
        newSectionDataAsign.push(null); // UN SOLO push, no dos
      }
    }

    setSubstructureSectionDataToggle(newSectionDataAsign);
    setSubstructureSectionToggle(newSectionAsign);
    setSubstructureDataToggle(newSubAsign);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetSubs]);

  const normalizedPolylines = useMemo(() => {
    return (polylineDisplay ?? []).map((polyline) => ({
      ...polyline,
      points: (polyline.points ?? []).map((p) => ({
        lat: p.latitude,
        lng: p.longitude,
        pk: p.pk,
        id_fo_poss: p.id_fo_poss,
        z: p.z,
      })),
    }));
  }, [polylineDisplay]);

  const handleChange = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const extension = file.name.split(".").pop().toLowerCase();
      const reader = new FileReader();

      reader.onload = (e) => {
        let read;

        try {
          if (extension === "json") {
            const text = e.target.result;
            read = JSON.parse(text);
          } else if (extension === "csv") {
            read = parseCSVToJson(e.target.result);
          } else {
            throw new Error("unsupported.format");
          }
        } catch (err) {
          console.error(err);
          setError("bad.json");
          return;
        }

        if (!read || !read.polylines || !Array.isArray(read.polylines)) {
          setError("bad.structure");
          return;
        }

        try {
          const polylineTypes = new Set(read.polylines.map((p) => p.equipment_type));

          const equipmentSet = new Set(equipmentCollection);

          const notIn = [...polylineTypes].filter((type) => !equipmentSet.has(type));

          const extra = [...equipmentSet].filter((type) => !polylineTypes.has(type));

          setBadEquipmentList([notIn, extra]);

          if (isEmpty(extra) && isEmpty(notIn)) {
            const uniquePolylines = Object.values(
              read.polylines.reduce((acc, polyline) => {
                const current = acc[polyline.id];

                if (!current || polyline.points.length < current.points.length) {
                  acc[polyline.id] = polyline;
                }

                return acc;
              }, {}),
            );

            const modifiedPolylines = uniquePolylines.map((polyline) => {
              const modifiedPoints = polyline.points.map((point) => {
                if (typeof point.latitude !== "number" || typeof point.longitude !== "number") {
                  throw new Error("bad.structure");
                }

                return {
                  ...point,
                  lat: point.latitude,
                  lng: point.longitude,
                };
              });

              return {
                ...polyline,
                points: modifiedPoints,
              };
            });

            setPolyline(read.polylines);
            setPolylineDisplay(modifiedPolylines);
            if (!isEmpty(equipment)) {
              setEquipment([]);
              setEdition(false);
              toast.info(intl.formatMessage({ id: "equipment.deleted" }), { className: "toast-info" });
            }
            setError("");
          }
        } catch (error) {
          console.error(error);
          setError("bad.structure");
        }
      };

      reader.readAsText(file);
    }
  };

  function parseCSVToJson(csvContent) {
    const lines = csvContent.split("\n");
    const headers = lines[0]?.split(",");
    const jsonData = [];

    for (let i = 1; i < lines.length; i++) {
      const currentLine = lines[i].split(",");
      if (currentLine.length !== headers.length) {
        continue;
      }

      const entry = {};
      for (let j = 0; j < headers.length; j++) {
        entry[headers[j]] = currentLine[j];
      }
      jsonData.push(entry);
    }

    return jsonData;
  }

  const [mapType, setMapType] = useState("regular");

  const AddCentroid = () => {
    // eslint-disable-next-line no-unused-vars
    const map = useMapEvents({
      click: (e) => {
        setCentroid([e.latlng.lat, e.latlng.lng]);
      },
    });
    return null;
  };
  const MyComponentSetView = ({ polyline }) => {
    const map = useMap();

    useEffect(() => {
      if (!isEmpty(polyline) && !isNil(polyline[0].points) && !isEmpty(polyline[0].points)) {
        map.fitBounds(polyline[0].points);
      }
      const currentZoom = map.getZoom();
      setZoom(currentZoom > 16 ? 16 : currentZoom);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [polyline, map]);

    return null;
  };

  return (
    <ThemeProvider theme={theme}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: "1%" }}>
        <input type="file" accept=".csv, .json" style={{ display: "none" }} id="file-input" onChange={handleChange} />
        <label htmlFor="file-input">
          <Button variant="contained" component="span">
            {intl.formatMessage({ id: "upload.file" })}
          </Button>
        </label>
        <h3 style={{ color: "red", marginLeft: "1rem" }}>
          {isEmpty(centroid) && intl.formatMessage({ id: "add.centroid" })}
        </h3>
        <h3 style={{ color: "red", marginLeft: "1rem" }}>{error.length > 0 && intl.formatMessage({ id: error })}</h3>
        {!isNil(badEquipmentList[0]) && !isEmpty(badEquipmentList[0]) && (
          <h3 style={{ color: "red", marginLeft: "1rem" }}>
            {intl.formatMessage({ id: "are.missing" })}
            {": "}
            {badEquipmentList[0].join(", ")}
          </h3>
        )}
        {!isNil(badEquipmentList[1]) && !isEmpty(badEquipmentList[1]) && (
          <h3 style={{ color: "red", marginLeft: "1rem" }}>
            {intl.formatMessage({ id: "unnecessary" })}
            {": "}
            {badEquipmentList[1].join(", ")}
          </h3>
        )}
      </div>
      <Grid Grid container direction="row" justifyContent="flex-start" alignItems="center">
        <Grid item style={{ flex: "1", marginRight: "1%" }}>
          <div
            style={{
              position: "relative",
              width: "100%",
              borderRadius: "4px",
              border: `1px solid ${palette.primary}`,
              margin: "1.5rem 0",
              padding: "1%",
            }}
          >
            <h1>{intl.formatMessage({ id: "subs" })}</h1>

            <IconButton
              style={{ backgroundColor: palette.dividerLight }}
              onClick={() => {
                /* añadir subs 
                hacer push a una lista de strings(?)*/
                let newAssetSubs = clone(assetSubs);
                let newZones = clone(zones);
                const maxChars = 36;
                newAssetSubs.push({
                  name: "",
                  ref: crypto.randomUUID().replaceAll("-", "").slice(0, maxChars),
                  type: "generic",
                  zones: [],
                  polyline: 0,
                  sections: null,
                  depth: null,
                  sublength: null,
                  sensors: [],
                  equipmentBehavior: null,
                });
                newZones[`sub${newAssetSubs.length}`] = [{ ini: 0, end: 10, alertsConfigurations: null }];
                setZones(newZones);
                setAssetSubs(newAssetSubs);
              }}
            >
              <AddIcon sx={{ color: palette.primary }} />
            </IconButton>

            {assetSubs?.map((assu, assuIndex) => (
              <>
                <h1
                  style={{ marginRight: "1%" }}
                  id={`sub${assuIndex}_collapse`}
                  onClick={() => {
                    let newChannel = clone(substructureDataToggle);
                    if (newChannel[assuIndex]) {
                      newChannel[assuIndex] = false;
                    } else {
                      newChannel[assuIndex] = true;
                    }
                    setSubstructureDataToggle(newChannel);
                  }}
                >
                  {intl.formatMessage({ id: "sub" })} {assuIndex + 1}
                  {!substructureDataToggle[assuIndex] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                  <DeleteForeverIcon
                    onClick={() => {
                      let newAssetSubs = clone(assetSubs);
                      let newZones = clone(zones);
                      delete newZones[`sub${assuIndex + 1}`];
                      newAssetSubs.splice(assuIndex, 1);
                      setAssetSubs(newAssetSubs);
                      setZones(newZones);
                    }}
                    sx={{ color: palette.primary, cursor: "pointer" }}
                  />
                </h1>
                <Collapse in={substructureDataToggle[assuIndex]}>
                  <TextField
                    id={`sub_name_${assuIndex}`}
                    style={{ width: "15rem", minWidth: 0, marginTop: "2%", marginBottom: "2%" }}
                    defaultValue={assu.name}
                    //disabled={mode === "edit"}
                    onBlur={(ev) => {
                      const newErrors = { ...errors };
                      if (isEmpty(ev.target.value)) {
                        newErrors[ev.target.id] = "not.empty";
                      } else {
                        delete newErrors[ev.target.id];
                      }
                      setErrors(newErrors);
                      let newAssetSubs = clone(assetSubs);

                      newAssetSubs[assuIndex].name = ev.target.value;
                      setAssetSubs(newAssetSubs);
                    }}
                    error={errors[`sub_name_${assuIndex}`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "sub.name" })}
                    required
                  />
                  {!isNil(errors[`sub_name_${assuIndex}`]) && (
                    <ErrorText>{intl.formatMessage({ id: errors[`sub_name_${assuIndex}`] })}</ErrorText>
                  )}
                  <TextField
                    id={`sub_type_${assuIndex}`}
                    variant="outlined"
                    //disabled={!moreSubsAllowed}
                    style={{ width: "15rem", minWidth: 0, marginRight: "1%" }}
                    label={intl.formatMessage({ id: "sub.type" })}
                    value={assu.type}
                    select
                    onChange={(ev) => {
                      let newAssetSubs = clone(assetSubs);

                      newAssetSubs[assuIndex].type = ev.target.value;
                      const polyNumber = newAssetSubs[assuIndex].polyline;
                      if (ev.target.value === "generic" && !Number.isInteger(polyNumber)) {
                        newAssetSubs[assuIndex].polyline = "";
                        newAssetSubs[assuIndex].subLength = 0;
                        newAssetSubs[assuIndex].depth = null;
                        newAssetSubs[assuIndex].sections = null;
                      } else if (ev.target.value === "inclinometer" && Number.isInteger(polyNumber)) {
                        newAssetSubs[assuIndex].polyline = [0, 0];
                        newAssetSubs[assuIndex].subLength = null;
                        newAssetSubs[assuIndex].depth = 50;
                        newAssetSubs[assuIndex].sections = [""];
                      }
                      setAssetSubs(newAssetSubs);
                    }}
                    error={errors[`sub_type_${assuIndex}`] ? true : false}
                    required
                  >
                    <MenuItem key={`sub_type_${assuIndex}_generic`} value={"generic"}>
                      Generic
                    </MenuItem>
                    <MenuItem key={`sub_type_${assuIndex}_inclinometer`} value={"inclinometer"}>
                      Inclinometer
                    </MenuItem>
                  </TextField>
                  {assetSubs[assuIndex].type === "inclinometer" && (
                    <Tooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">{intl.formatMessage({ id: "sub.section" })}</Typography>
                        </React.Fragment>
                      }
                    >
                      <TextField
                        id={`sub_sectioncount_${assuIndex}`}
                        style={{ width: "12rem", minWidth: 0, marginBottom: "2%" }}
                        defaultValue={assetSubs[assuIndex].sections.length}
                        inputProps={{ min: 1 }}
                        onChange={(ev) => {
                          const value = parseInt(ev.target.value);
                          const newErrors = { ...errors };
                          if (isEmpty(ev.target.value) || isNaN(value)) {
                            newErrors[ev.target.id] = "not.empty";
                          } else if (value < 1) {
                            newErrors[ev.target.id] = "min.value.surpassed";
                          } else {
                            delete newErrors[ev.target.id];
                          }
                          setErrors(newErrors);
                          let newAssetSubs = clone(assetSubs);
                          const newSection = [];
                          for (let indexSection = 0; indexSection < parseInt(ev.target.value); indexSection++) {
                            if (isNil(newAssetSubs[assuIndex].sections[indexSection])) {
                              newSection.push("");
                            } else {
                              newSection.push(newAssetSubs[assuIndex].sections[indexSection]);
                            }
                          }
                          newAssetSubs[assuIndex].sections = newSection;
                          setAssetSubs(newAssetSubs);
                        }}
                        type="number"
                        error={errors[`sub_sectioncount_${assuIndex}`] ? true : false}
                        variant="outlined"
                        label={intl.formatMessage({ id: "sub.section" })}
                        required
                      />
                    </Tooltip>
                  )}
                  {/* Polyline select OR lat/lon inputs */}
                  {assetSubs[assuIndex].type === "generic" ? (
                    <>
                      <TextField
                        id={"sub" + assuIndex + "_poly"}
                        variant="outlined"
                        label={intl.formatMessage({ id: "polyline" })}
                        sty
                        onChange={(ev) => {
                          let newAssetSubs = clone(assetSubs);
                          newAssetSubs[assuIndex].polyline = ev.target.value;
                          setHoveredPolylineIndex(null);
                          setAssetSubs(newAssetSubs);
                        }}
                        defaultValue={assetSubs[assuIndex].polyline}
                        onMouseOut={() => {
                          setHoveredPolylineIndex(null);
                        }}
                        style={{ width: "10rem", minWidth: 0 }}
                        select
                      >
                        {polylineDisplay.map((p, indPoly) => {
                          return (
                            <MenuItem
                              key={"sub" + assuIndex + "_" + indPoly}
                              value={p.id}
                              onMouseOver={() => {
                                setHoveredPolylineIndex(null);
                                setTimeout(() => {
                                  setHoveredPolylineIndex(indPoly);
                                }, 0);
                              }}
                              onMouseOut={() => {
                                setHoveredPolylineIndex(null);
                              }}
                            >
                              {p.id}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </>
                  ) : (
                    <div style={{ display: "flex", gap: "0.5rem" }}>
                      <TextField
                        id={`section_depth_${assuIndex}`}
                        style={{ width: "5.5rem", minWidth: 0, marginTop: "2%" }}
                        inputProps={{ min: 0 }}
                        defaultValue={assetSubs[assuIndex].depth}
                        onBlur={(ev) => {
                          const value = parseFloat(ev.target.value);
                          const newErrors = { ...errors };
                          if (isEmpty(ev.target.value) || isNaN(value)) {
                            newErrors[ev.target.id] = "not.empty";
                          } else if (value < 0) {
                            newErrors[ev.target.id] = "min.value.surpassed";
                          } else {
                            delete newErrors[ev.target.id];
                          }
                          setErrors(newErrors);
                          let newAssetSubs = clone(assetSubs);
                          if (!Number.isNaN(parseFloat(ev.target.value)) && !isNil(ev.target.value)) {
                            newAssetSubs[assuIndex].depth = parseFloat(ev.target.value);
                          }
                          setAssetSubs(newAssetSubs);
                        }}
                        variant="outlined"
                        error={errors[`section_depth_${assuIndex}`] ? true : false}
                        label={intl.formatMessage({ id: "depth" })}
                        required
                        type="number"
                      />{" "}
                      {!isNil(errors[`section_depth_${assuIndex}`]) && (
                        <ErrorText>
                          {intl.formatMessage({
                            id: errors[`section_depth_${assuIndex}`],
                          })}
                        </ErrorText>
                      )}
                      <TextField
                        id={`sub_lat_${assuIndex}`}
                        style={{ width: "6.5rem", minWidth: 0, marginTop: "2%" }}
                        defaultValue={assetSubs[assuIndex].polyline[0]}
                        inputProps={{ min: -180, max: 180 }}
                        onChange={(ev) => {
                          const value = parseFloat(ev.target.value);
                          const newErrors = { ...errors };
                          if (isEmpty(ev.target.value) || isNaN(value)) {
                            newErrors[ev.target.id] = "not.empty";
                          } else if (value < -180) {
                            newErrors[ev.target.id] = "min.value.surpassed";
                          } else if (value > 180) {
                            newErrors[ev.target.id] = "max.value.surpassed";
                          } else {
                            delete newErrors[ev.target.id];
                          }
                          setErrors(newErrors);
                          let newAssetSubs = clone(assetSubs);
                          if (!Number.isNaN(parseFloat(ev.target.value)) && !isNil(ev.target.value)) {
                            newAssetSubs[assuIndex].polyline[0] = parseFloat(ev.target.value);
                          }
                          setAssetSubs(newAssetSubs);
                        }}
                        type="number"
                        error={errors[`sub_lat_${assuIndex}`] ? true : false}
                        variant="outlined"
                        label={intl.formatMessage({ id: "latitude" })}
                        required
                      />
                      {!isNil(errors[`sub_lat_${assuIndex}`]) && (
                        <ErrorText>
                          {intl.formatMessage({
                            id: errors[`sub_lat_${assuIndex}`],
                          })}
                        </ErrorText>
                      )}
                      <TextField
                        id={`sub_lon_${assuIndex}`}
                        style={{ width: "6.5rem", minWidth: 0, marginTop: "2%" }}
                        defaultValue={assetSubs[assuIndex].polyline[1]}
                        inputProps={{ min: -180, max: 180 }}
                        onChange={(ev) => {
                          const value = parseFloat(ev.target.value);
                          const newErrors = { ...errors };
                          if (isEmpty(ev.target.value) || isNaN(value)) {
                            newErrors[ev.target.id] = "not.empty";
                          } else if (value < -180) {
                            newErrors[ev.target.id] = "min.value.surpassed";
                          } else if (value > 180) {
                            newErrors[ev.target.id] = "max.value.surpassed";
                          } else {
                            delete newErrors[ev.target.id];
                          }
                          setErrors(newErrors);
                          let newAssetSubs = clone(assetSubs);
                          if (!Number.isNaN(parseFloat(ev.target.value)) && !isNil(ev.target.value)) {
                            newAssetSubs[assuIndex].polyline[1] = parseFloat(ev.target.value);
                          }
                          setAssetSubs(newAssetSubs);
                        }}
                        type="number"
                        error={errors[`sub_lon_${assuIndex}`] ? true : false}
                        variant="outlined"
                        label={intl.formatMessage({ id: "longitude" })}
                        required
                      />{" "}
                      {!isNil(errors[`sub_lon_${assuIndex}`]) && (
                        <ErrorText>
                          {intl.formatMessage({
                            id: errors[`sub_lon_${assuIndex}`],
                          })}
                        </ErrorText>
                      )}
                    </div>
                  )}
                  {assetSubs[assuIndex].type === "inclinometer" && (
                    <BootstrapButton
                      variant="contained"
                      style={{ margin: "0.5rem 0.2rem 0.8rem" }}
                      id="substructures-to-channels"
                      onClick={() => {
                        let newSection = clone(substructureSectionToggle);
                        if (newSection[assuIndex]) {
                          newSection[assuIndex] = false;
                        } else {
                          newSection[assuIndex] = true;
                        }
                        setSubstructureSectionToggle(newSection);
                      }}
                    >
                      {intl.formatMessage({ id: "sections" })}
                      {!substructureSectionToggle[assuIndex] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                    </BootstrapButton>
                  )}
                  <Collapse in={substructureSectionToggle[assuIndex]}>
                    {assetSubs[assuIndex].type === "inclinometer" &&
                      assetSubs[assuIndex].sections.map((section, indexSection) => {
                        return (
                          <>
                            <Button
                              variant="contained"
                              style={{ margin: "5%", backgroundColor: palette.secondary, color: "white" }}
                              id={`collapseSub${assuIndex}_${indexSection}`}
                              onClick={() => {
                                let newA = clone(substructureSectionDataToggle);
                                newA[assuIndex][indexSection] = true;
                                setSubstructureSectionDataToggle(newA);
                              }}
                            >
                              {intl.formatMessage({ id: "section" })} {indexSection + 1}
                            </Button>
                            <ModalSectionInfo
                              key={`collapse_form_Sub${assuIndex}_${indexSection}`}
                              indexSection={indexSection}
                              substructureSectionDataToggle={substructureSectionDataToggle}
                              setSubstructureSectionDataToggle={setSubstructureSectionDataToggle}
                              assetSubs={assetSubs}
                              setAssetSubs={setAssetSubs}
                              indexAssetSub={assuIndex}
                              intl={intl}
                            />
                          </>
                        );
                      })}
                  </Collapse>
                  {edition && !isNil(assetSensors) && !isEmpty(assetSensors) && (
                    <Autocomplete
                      multiple
                      id="multiple-checkboxes"
                      options={assetSensors}
                      sx={{ width: "15rem", marginBottom: "1%", marginTop: "1%" }}
                      disableCloseOnSelect
                      // disabled={disabled}
                      onChange={(event, values) => {
                        let newAssetSubs = clone(assetSubs);
                        newAssetSubs[assuIndex].sensors = values;
                        setAssetSubs(newAssetSubs);
                      }}
                      getOptionLabel={(option) => option}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox style={{ marginRight: 8 }} checked={selected} />
                          {intl.formatMessage({ id: option })}
                        </li>
                      )}
                      value={isNil(assetSubs[assuIndex].sensors) ? [] : assetSubs[assuIndex].sensors}
                      renderInput={(params) => (
                        <TextField {...params} variant="outlined" label={intl.formatMessage({ id: "sensor.ids" })} />
                      )}
                    />
                  )}
                </Collapse>
              </>
            ))}
          </div>
        </Grid>
        <Grid item style={{ flex: "2" }}>
          <MapContainer
            id="map-id"
            center={
              !isEmpty(normalizedPolylines) && normalizedPolylines[0]?.points.length > 0
                ? normalizedPolylines[0]?.points[Math.round(normalizedPolylines[0]?.points.length / 2)]
                : [27.337882, -27.919657]
            }
            zoom={!isEmpty(normalizedPolylines) && normalizedPolylines[0]?.points.length > 0 ? 10 : 3}
            style={{ height: "calc(100vh - 320px)", width: "60vw" }}
            anima
            rotateControl={false}
          >
            <TileLayer
              attribution={window.RUNTIME_CONFIG.IS_ONLINE ? "Google Maps" : "OpenStreetMap"}
              url={window.RUNTIME_CONFIG.MAP_TYPES.find((type) => type.value === mapType).tileLayer}
              maxZoom={18}
              subdomains={["mt0", "mt1", "mt2", "mt3"]}
            />
            <MyComponentSetView polyline={normalizedPolylines} />
            {normalizedPolylines.length > 0 &&
              // eslint-disable-next-line array-callback-return
              normalizedPolylines.map((polyline, index) => {
                // eslint-disable-next-line array-callback-return
                return polyline.points.map((point, indice) => {
                  if (indice === 0 || polyline.must_graph_points.indexOf(indice) === 0) {
                    return null;
                  }

                  if (polyline.must_graph_points.includes(indice)) {
                    const previousIndex = polyline.must_graph_points[polyline.must_graph_points.indexOf(indice) - 1];
                    const center = [
                      [
                        normalizedPolylines[index].points[previousIndex].lat,
                        normalizedPolylines[index].points[previousIndex].lng,
                      ],
                      [point.lat, point.lng],
                    ];
                    const color = normalizedPolylines.length > 10 ? "black" : polylineColors[index];
                    return <Polyline key={indice + "_" + index} color={color} positions={center} weight={5}></Polyline>;
                  }
                });
              })}
            <AddCentroid />
            {centroid.length > 0 && <Marker key={"Centroid"} position={centroid} icon={customIcon}></Marker>}

            {window.RUNTIME_CONFIG.IS_ONLINE ?? (
              <MapTypeContent>
                <MapTypeSelector items={window.RUNTIME_CONFIG.MAP_TYPES} onChange={setMapType} color={palette.dark} />
              </MapTypeContent>
            )}
          </MapContainer>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};
export default PolylineData;
